import { UserRole } from '@mairistem/finances-utils';
import TypePeriode from '../../constants/simulation/typePeriode';

// Permet de savoir si on desactive les champs par manque d'habilitation
const isInputDisabled = (
	transfertCpta: boolean,
	typePeriode: TypePeriode,
	userRole: UserRole,
	gestionnaireCanWhenDemande = false,
) => {
	// Si on est transfere en compta, plus de modification de montant
	if (transfertCpta) return true;

	switch (typePeriode) {
		case TypePeriode.DEMANDE:
			// Admin/ChargePilotage/(Gestionnaire si autorise)
			return (
				userRole <
				(gestionnaireCanWhenDemande
					? UserRole.GESTIONNAIRE
					: UserRole.CHARGE_PILOTAGE)
			);
		case TypePeriode.CA_CFU:
		case TypePeriode.PROPOSE:
		case TypePeriode.VOTE:
			// Admin/ChargePilotage
			return userRole < UserRole.CHARGE_PILOTAGE;
		default:
			return true;
	}
};

export default isInputDisabled;
